/**
 * Created by neo on 29.12.22.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { ExploreEntry } from '../../Model/Explore/ExploreEntry';
import { useLocalized } from '../../Hooks/useLocalized';
import styled from '@emotion/styled';
import { Recipe } from '../../Model/Diet/Recipe/Recipe';

const Title = styled.p`
  font-weight: 600;
  color: black;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Limit to 2 lines */
  -webkit-box-orient: vertical;
  flex-shrink: 1; /* Allow shrinking */
`;

export type ExploreCardTitleProps = {
  entry: ExploreEntry | Recipe;
};

export const ExploreCardTitle: React.FC<ExploreCardTitleProps> = observer(({ entry }) => {
  const entryTitle = useLocalized(entry.name);

  return <Title>{entryTitle.toUpperCase()}</Title>;
});
